"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalContextMenu = exports.FileItemMenuItem = void 0;
const React = __importStar(require("react"));
const ReactDom = __importStar(require("react-dom"));
const react_contextmenu_1 = require("react-contextmenu");
const binary_modal_1 = require("./binary-modal");
const layout_1 = require("./shared/layout");
// have this component hold all the logic / exports for us interacting with this 'react-contextmenu' library 
// it looks like that has been abandoned by its maintainers so we should have it in a single placed rather than sprinkled around the app
var react_contextmenu_2 = require("react-contextmenu");
Object.defineProperty(exports, "ContextMenuTrigger", { enumerable: true, get: function () { return react_contextmenu_2.ContextMenuTrigger; } });
Object.defineProperty(exports, "MenuItem", { enumerable: true, get: function () { return react_contextmenu_2.MenuItem; } });
;
function FileItemMenuItem(item) {
    if (item === "Separator") {
        return React.createElement(react_contextmenu_1.MenuItem, { divider: true });
    }
    // Wrap action in confirmation if required
    const action = item.RequireConfirmation
        ? DoAfterConfirmation(item.Action, item.RequireConfirmation)
        : item.Action;
    return React.createElement(react_contextmenu_1.MenuItem, null,
        React.createElement(layout_1.FlexRow, { style: { alignItems: "center", fontWeight: item.Emphasize ? "bold" : undefined }, onClick: e => { action(); }, key: item.Name, className: item.ClassName || "" }, item.DisplayName || item.Name));
}
exports.FileItemMenuItem = FileItemMenuItem;
exports.PortalContextMenu = props => ReactDom.createPortal(React.createElement(react_contextmenu_1.ContextMenu, Object.assign({}, props), props.children), document.body);
function DoAfterConfirmation(action, props) {
    return () => __awaiter(this, void 0, void 0, function* () {
        const confirmed = yield binary_modal_1.PromptForBinaryChoice(props);
        if (confirmed) {
            action();
        }
    });
}
//# sourceMappingURL=portal-context-menu.js.map